import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import QRCode from "qrcode.react";
import Barcode from "react-barcode";
import axios from "axios";
import styles from "./styles/print.module.css";
import { getOrderDetail } from "services/ordersApi";
import { useGetTransportType } from "hooks/useMasterData";

const fetchAddress = async (orderId: string) => {
  try {
    //const response = await axios.get(`https://2a4737a1-1631-48ab-9f3b-3a2183673d9d.mock.pstmn.io/address/${orderId}`);
    const response = await getOrderDetail({
      key_type: "order_id",
      group_by: "factory",
      items: [orderId ?? ""],
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching address:", error);
    return null;
  }
};

const PrintLabelDelivery = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const boxCount = searchParams.get("boxcount");

  //  console.log(orderId);

  const { data: transportTypeData } = useGetTransportType();

  const [pageCnt, setPageCnt] = useState(boxCount || 1);
  const [cusName, setCusName] = useState("");
  const [cusTel, setCusTel] = useState("");
  const [line1, setLine1] = useState("");
  const [line2, setLine2] = useState("");
  const [line3, setLine3] = useState("");
  const [shipType, setShipType] = useState("");
  //console.log(orderId);
  const contentRef = useRef<HTMLDivElement>(null);

  const [geographyName, setGeographyName] = useState("");

  const resizeText = () => {
    const content = contentRef.current;
    if (!content) return;

    let fontSize = parseFloat(window.getComputedStyle(content).fontSize) / 16; // Convert px to em
    const contentHeight = content.scrollHeight;
    const contentWidth = content.scrollWidth;
    const containerHeight = content.clientHeight;
    const containerWidth = content.clientWidth;

    while (
      (contentHeight > containerHeight || contentWidth > containerWidth) &&
      fontSize > 0.8
    ) {
      fontSize -= 0.05;
      content.style.fontSize = `${fontSize}em`;
    }
  };

  useEffect(() => {
    const getAddress = async () => {
      if (!orderId) {
        console.error("No orderId provided");
        return;
      }

      const addressData = await fetchAddress(orderId);
      if (addressData) {
        // const { name, tel, addressLine1, addressLine2, addressLine3, shippingType } = addressData;

        setGeographyName(addressData[0].geography_name_en)

        const name = addressData[0]?.address_name || "";
        const tel = addressData[0]?.address_telephone || "";

        let addressLine1 = "";
        let addressLine2 = "";
        let addressLine3 = "";

        if (addressData[0]?.transport_type === "post_office" || addressData[0]?.transport_type === "taxi"  ) {
          addressLine2 = addressData[0]?.address_text || "";
          addressLine3 =  addressData[0]?.history_postal.postal_remark
        } 
        else if(addressData[0]?.transport_type === "pick_up_yourself") {
          addressLine1 ="รับที่โรงงาน";
          addressLine2 = addressData[0]?.history_transport_location.location_remark || "";
        }
        else {
          addressLine1 =
            addressData[0]?.history_transport.history_parking_name.substring(
              0,
              32
            ) || "";
          addressLine2 = addressData[0]?.history_transport.remark_box || "";
        }

        const shippingType =
          transportTypeData?.find(
            (item) => item.key === addressData[0]?.transport_type
          )?.name || "";

        setCusName(name);
        setCusTel(tel);
        setLine1(addressLine1);
        setLine2(addressLine2);
        setLine3(addressLine3);
        setShipType(shippingType);

        // Resize text after setting the address
        resizeText();

        // Print after setting the address
        setTimeout(() => {
          window.print();
        }, 500); // Delay for a brief moment to ensure the DOM is updated
      }
    };

    getAddress();
    window.addEventListener("resize", resizeText);

    return () => {
      window.removeEventListener("resize", resizeText);
    };
  }, [orderId, transportTypeData]);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @page {
        size: 10cm 8cm;
        margin: 0;
      }
      body {
        margin: 0;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className={styles.printContainer}>
      <div className={styles.printContent}>
        {/* ใส่เนื้อหาที่ต้องการพิมพ์ที่นี่ */}
        <div className={styles.printContentText} ref={contentRef}>
          <div
            className={styles.templateH1}
            style={{ display: "flex", justifyContent: "center" }}
          >
            {cusName}{" "}
          </div>
          <div
            className={styles.templateH2}
            style={{ display: "flex", justifyContent: "left" }}
          >
            โทร. {cusTel}
          </div>
          <div className={styles.templateH1}>{line1} </div>
          <div className={styles.templateH2}>{line2} </div>
          <div className={styles.templateH3}>{line3} </div>
        </div>

        <div className={styles.barcode}>
          <Barcode
            value={orderId || ""}
            height={30}
            width={0.6}
            displayValue={true}
            fontSize={10}
          />
        </div>
        <div className={styles.qrcode}>
          {" "}
          <div className={styles.qrcode}>
            <QRCode value={`Order ID: ${orderId}`} size={70} />
          </div>{" "}
        </div>
        <div className={styles.reciveBox}>จำนวนที่ได้รับ</div>

        
       
        <div className={geographyName ==="South" ? styles.bottomRightWhite : styles.bottomRight }>
          <div>{pageCnt}</div>
          <div className={ geographyName ==="South" ? styles.shipTypeWhite : styles.shipType}>{shipType}</div>
        </div>
      </div>
    </div>
  );
};

export default PrintLabelDelivery;
